import "../../css/choice-selector.css"
import React, {FC, useState} from "react";
import {Guest, OpenEndedSelectionRequest, RsvpRequest} from "../../../../types/Guests";
import {Choice, ChoiceOption, ChoiceResponse} from "../../../../types/Choices";
import Select, {Options} from "../../../../components/form/Select";

interface MyComponentProps {
    rsvpMap:Map<number, RsvpRequest>
    choices:Map<number, ChoiceResponse>
    guest:Guest
}

const ChoiceSelector:FC<MyComponentProps> = ({ rsvpMap, choices, guest }) => {

    const initialSelectedIds = (): number[] => {
        const fromRsvpMap = rsvpMap.get(guest.id)?.optionIds ?? [];
        const fromSelections = (choices.get(guest.id)?.choices ?? [])
            .map(c => c.selection?.optionId)
            .filter((id): id is number => id !== undefined);
        return Array.from(new Set([...fromRsvpMap, ...fromSelections]));
    };

    const [selectedOptionIds, setSelectedOptionIds] = useState<number[]>(initialSelectedIds);

    const handleSelectChoice = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const index = event.target.selectedIndex;
        const option = event.target.options[index];
        const selectedId = parseInt(option.id);

        let rsvp = rsvpMap.get(guest.id);

        let choiceOptions = Array.from(event.target.options).map(o => parseInt(o.id));

        if (rsvp) {
            rsvp.optionIds = rsvp.optionIds.filter(o => !choiceOptions.includes(o));
            if (!isNaN(selectedId)) {
                rsvp.optionIds.push(selectedId);
            }
            rsvpMap.set(guest.id, rsvp);
        }

        setSelectedOptionIds(prev => {
            const withoutThisChoice = prev.filter(id => !choiceOptions.includes(id));
            return isNaN(selectedId) ? withoutThisChoice : [...withoutThisChoice, selectedId];
        });
    }

    const handleOpenEndedChange = (event: React.ChangeEvent<HTMLInputElement>, choiceId: number) => {
        let rsvp = rsvpMap.get(guest.id);

        if (rsvp) {
            const responses: OpenEndedSelectionRequest[] = rsvp.openEndedResponses
                ? rsvp.openEndedResponses.filter(r => r.choiceId !== choiceId)
                : [];

            if (event.target.value.trim()) {
                responses.push({ choiceId, response: event.target.value });
            }

            rsvp.openEndedResponses = responses;
            rsvpMap.set(guest.id, rsvp);
        }
    }

    const buildOptions = (options:ChoiceOption[]):Options[] => {
        return options.map(o => {
            let opt:Options = {
                id: o.id.toString(),
                value: o.option
            };

            return opt;
        })
    }

    const getSelectedValue = (choice: Choice): string => {
        if (choice.selection?.optionId) {
            const selectedOption = choice.options.find((o: ChoiceOption) => o.id === choice.selection?.optionId);
            return selectedOption ? selectedOption.option : "";
        }
        return "";
    }

    const getOpenEndedValue = (choice: Choice): string => {
        const rsvp = rsvpMap.get(guest.id);
        const saved = rsvp?.openEndedResponses?.find(r => r.choiceId === choice.choiceId);
        if (saved) return saved.response;
        return choice.selection?.textResponse ?? "";
    }

    // Check both the rsvpMap (for new selections) and guest.status (for loaded data)
    const rsvpMapStatus = rsvpMap.get(guest.id)?.status;
    const isRsvping = rsvpMapStatus === "RSVP" || guest.status === "RSVP";

    return (
        <>
            {choices && choices.has(guest.id) && isRsvping &&
                <div className="choice__selector-guest">
                    <h1>{`${guest.firstName} ${guest.lastName}`}</h1>

                    {
                        choices.has(guest.id) && [...(choices.get(guest.id)?.choices ?? [])]
                            .sort((a, b) => a.order - b.order)
                            .filter((choice) => {
                                if (choice.requirements.length === 0) return true;
                                return choice.requirements.some(reqId => selectedOptionIds.includes(reqId));
                            })
                            .map((choice) => {
                            return (
                                <div key={`choice_${choice.choiceId}_guest_${guest.id}`}>
                                    <h2>{choice.choiceName}</h2>
                                    {choice.openEnded ? (
                                        <div className="form__input">
                                            <div className="form__input-field">
                                                <input
                                                    type="text"
                                                    name={`guest_${guest.id}_choice_${choice.choiceId}`}
                                                    placeholder="Your response..."
                                                    defaultValue={getOpenEndedValue(choice)}
                                                    onChange={(e) => handleOpenEndedChange(e, choice.choiceId)}
                                                />
                                            </div>
                                        </div>
                                    ) : (
                                        <Select
                                            id={`choice_${choice.choiceId}_guest_${guest.id}`}
                                            onChange={handleSelectChoice}
                                            name={`guest_${guest.id}_choice_${choice.choiceId}`}
                                            value={getSelectedValue(choice)}
                                            title={""}
                                            options={buildOptions(choice.options)}
                                        />
                                    )}
                                </div>
                            )
                        })
                    }
                </div>
            }
        </>

    );
};

export default ChoiceSelector;
